import styled from 'styled-components/macro';
import SimpleButton from 'styled/Buttons/SimpleButton';
import { COLORS } from 'styleguide';

const BanButton = styled(SimpleButton)`
  width: 24px;
  height: 24px;
  font-size: 16px;
  color: ${({ ban }) => (ban ? COLORS.error : '#fff')};

  svg {
    opacity: 0.4;
    transition: opacity 0.15s ease-out;
  }

  &:hover svg {
    opacity: 1;
  }

  &:focus {
    outline-color: ${COLORS.primary};
  }
`;

export default BanButton;
